import config from "config/index";

// Store last page_view event in sessionStorage
const LAST_EVENT_KEY = "last_page_view_event";

// Log event to backend
export const logEvent = async (eventData = {}) => {
  try {
    const now = new Date();
console.log(eventData.event_type,"eventData.event_type")
    // Only update end_time for page_view
    if (eventData.event_type === "page_view") {
      // const lastEventJson = sessionStorage.getItem(LAST_EVENT_KEY);
      console.log(LAST_EVENT_KEY,"eventData.event_type")
      // if (lastEventJson) {
        // const lastEvent = JSON.parse(lastEventJson);
        // await fetch(`${config.host}/cdr-panel/analytics/${lastEvent.id}`, {
        //   method: "PATCH",
        //   credentials: "include",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({ end_time: now.toISOString() }),
        // });
      // }
    }

    // Create new event payload
    // const payload = {
    //   event_type: eventData.event_type || "custom",
    //   event_name: eventData.event_name || "unknown_event",
    //   page_url: eventData.page_url || window.location.href,
    //   browser: eventData.browser || navigator.userAgent,
    //   os: eventData.os || getOS(),
    //   user_id: eventData.user_id || null,
    //   session_id: eventData.session_id || getSessionId(),
    //   timestamp_client: Date.now(),
    //   start_time: now.toISOString(),
    //   end_time: null,
    //   metadata: eventData.metadata || {},
    // };

    // const res = await fetch(`${config.host}/cdr-panel/analytics`, {
    //   method: "POST",
    //   credentials: "include",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(payload),
    // });

    // if (!res.ok) throw new Error(`Failed to log event: ${res.status}`);

    // const data = await res.json();

    // Save new page_view event to sessionStorage
    // if (eventData.event_type === "page_view") {
    //   sessionStorage.setItem(LAST_EVENT_KEY, JSON.stringify({ id: data.id }));
    // }

    return true;
  } catch (error) {
    console.error("Failed to log analytics event:", error);
  }
};

// Update last event on page exit
window.addEventListener("beforeunload", async () => {
  const lastEventJson = sessionStorage.getItem(LAST_EVENT_KEY);
  if (lastEventJson) {
    const lastEvent = JSON.parse(lastEventJson);
    await fetch(`${config.host}/cdr-panel/analytics/${lastEvent.id}`, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ end_time: new Date().toISOString() }),
    });
  }
});

// Helper functions
export function getOS() {
  const platform = navigator.platform.toLowerCase();
  if (platform.includes("win")) return "Windows";
  if (platform.includes("mac")) return "MacOS";
  if (platform.includes("linux")) return "Linux";
  if (/android/.test(navigator.userAgent.toLowerCase())) return "Android";
  if (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) return "iOS";
  return "Unknown";
}

export function getSessionId() {
  let sid = sessionStorage.getItem("session_id");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("session_id", sid);
  }
  return sid;
}
